import * as L from 'leaflet';
import companyLocation from './Icons/svg/tropfen-zentrale.svg';
import iconShadow from './Icons/svg/tropfen-shadow.svg';
import suggestionDrop from './Icons/svg/tropfen-leer_schraffur.svg';
import depotDropIcon from './Icons/svg/tropfen-depot_orange.svg';
import tourstartIcon from './Icons/svg/tropfen-tourstart.svg';
import tourendIcon from './Icons/svg/tropfen-tourende.svg';
import pickupDrop from './Icons/svg/tropfen_pickup_blau_old.svg';
import standardDrop from './Icons/svg/tropfen-leer-nachtblau.svg';
import standardDropMarked from './Icons/svg/tropfen-leer.svg';
import deliveryDrop from './Icons/svg/tropfen_delivery_blau_old.svg';
import deliveryDropMarked from './Icons/svg/tropfen-delivery_blau_markiert.svg';
import pickupDropMarked from './Icons/svg/tropfen_pickup_blau_markiert.svg';
import commonStartEndIcon from './Icons/svg/tropfen-tourstartend.svg';

export const companyIcon = L.icon({
  iconUrl: companyLocation,
  shadowUrl: iconShadow,
  iconSize: [48, 48],
  iconAnchor: [24, 48],
  shadowSize: [48, 24],
  shadowAnchor: [17, 24]
});

export const suggestionIcon = L.icon({
  iconUrl: suggestionDrop,
  shadowUrl: iconShadow,
  iconSize: [48, 48],
  iconAnchor: [24, 48],
  shadowSize: [48, 24],
  shadowAnchor: [17, 24]
});

export const depotIcon = L.icon({
  iconUrl: depotDropIcon,
  shadowUrl: iconShadow,
  iconSize: [48, 48],
  iconAnchor: [24, 48],
  shadowSize: [48, 24],
  shadowAnchor: [17, 24]
});

export const tourStartIcon = L.icon({
  iconUrl: tourstartIcon,
  shadowUrl: iconShadow,
  iconSize: [48, 48],
  iconAnchor: [24, 48],
  shadowSize: [48, 24],
  shadowAnchor: [17, 24]
});

export const tourStartEndIcon = L.icon({
  iconUrl: commonStartEndIcon,
  shadowUrl: iconShadow,
  iconSize: [48, 48],
  iconAnchor: [24, 48],
  shadowSize: [48, 24],
  shadowAnchor: [17, 24]
});

export const tourEndIcon = L.icon({
  iconUrl: tourendIcon,
  shadowUrl: iconShadow,
  iconSize: [48, 48],
  iconAnchor: [24, 48],
  shadowSize: [48, 24],
  shadowAnchor: [17, 24]
});

export const pickupIcon = L.icon({
  iconUrl: pickupDrop,
  shadowUrl: iconShadow,
  iconSize: [48, 48],
  iconAnchor: [24, 48],
  shadowSize: [48, 24],
  shadowAnchor: [17, 24]
});

export const regularIcon = L.icon({
  iconUrl: standardDrop,
  shadowUrl: iconShadow,
  iconSize: [48, 48],
  iconAnchor: [24, 48],
  shadowSize: [48, 24],
  shadowAnchor: [17, 24]
});
export const regularIconMarked = L.icon({
  iconUrl: standardDropMarked,
  shadowUrl: iconShadow,
  iconSize: [48, 48],
  iconAnchor: [24, 48],
  shadowSize: [48, 24],
  shadowAnchor: [17, 24]
});

export const deliveryIcon = L.icon({
  iconUrl: deliveryDrop,
  shadowUrl: iconShadow,
  iconSize: [48, 48],
  iconAnchor: [24, 48],
  shadowSize: [48, 24],
  shadowAnchor: [17, 24]
});

export const deliveryIconMarked = L.icon({
  iconUrl: deliveryDropMarked,
  shadowUrl: iconShadow,
  iconSize: [48, 48],
  iconAnchor: [24, 48],
  shadowSize: [48, 24],
  shadowAnchor: [17, 24]
});

export const pickupIconMarked = L.icon({
  iconUrl: pickupDropMarked,
  shadowUrl: iconShadow,
  iconSize: [48, 48],
  iconAnchor: [24, 48],
  shadowSize: [48, 24],
  shadowAnchor: [17, 24]
});

const truckSvg = color => {
  let res = '<svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="512px" height="518.6px" viewBox="0 0 512 518.6" style="enable-background:new 0 0 512 518.6" xml:space="preserve">';
  res = +'<style type="text/css">.st0{fill:#' + color + 'stroke:#FFFFFFstroke-width:6stroke-miterlimit:10}.st1{fill:#FFFFFF}</style>';
  res = +'<g id="Capa_1"><path class="st0" d="M265,3.3C161.1,3.3,76.5,87.8,76.5,191.8c0,27.1,5.5,53,16.5,76.9c47.1,103.1,137.5,212,164.1,242.9c2,2.3,4.9,3.6,7.9,3.6c3.1,0,6-1.3,7.9-3.6c26.6-30.9,116.9-139.8,164.1-242.9c10.9-23.9,16.5-49.8,16.5-76.9C453.5,87.8,368.9,3.3,265,3.3z"/></g>';
  res = +'<g id="Ebene_2"><path class="st1" d="M213.2,238.1h94.4c2.2,10.6,11.6,18.7,22.9,18.7s20.7-8,22.9-18.7h15c2.6,0,4.7-2.1,4.7-4.7V122.3c0-2.6-2.1-4.7-4.7-4.7H224.8c-2.6,0-4.7,2.1-4.7,4.7v6.2h-38.8c-9,0-16.7,6.1-18.8,14.9l-7.7,33l-13.5,7.8c-1.4,0.8-2.3,2.4-2.3,4v45.2c0,2.6,2.1,4.7,4.7,4.7h23.8c2.2,10.6,11.6,18.7,22.9,18.7C201.6,256.7,211.1,248.7,213.2,238.1L213.2,238.1z M181.3,137.8h11.8v36.9h-28.3l6.8-29.2C172.7,140.9,176.7,137.8,181.3,137.8z M363.7,195.3H229.4v-62.2V127h134.2v68.3H363.7z M363.7,228.7h-10.3c-2.2-10.6-11.6-18.7-22.9-18.7s-20.7,8-22.9,18.7h-78.2v-7.4h42c2.6,0,4.7-2.1,4.7-4.7c0-2.6-2.1-4.7-4.7-4.7h-42v-7.4h134.2L363.7,228.7L363.7,228.7z M316.5,233.4c0-7.7,6.3-14,14-14s14,6.3,14,14s-6.3,14-14,14C322.7,247.4,316.5,241.1,316.5,233.4z M176.3,233.4c0-7.7,6.3-14,14-14c7.4,0,13.5,5.8,14,13.1c-0.1,0.3-0.1,0.6-0.1,0.9c0,0.3,0,0.6,0.1,0.9c-0.5,7.3-6.6,13.1-14,13.1C182.6,247.4,176.3,241.1,176.3,233.4z M220.1,228.7h-6.9c-2.2-10.6-11.6-18.7-22.9-18.7c-11.3,0-20.7,8-22.9,18.7h-19.2v-12.8h13.5c2.6,0,4.7-2.1,4.7-4.7V197c0-2.6-2.1-4.7-4.7-4.7h-13.5v-1.5l11.8-6.9h37.6c2.6,0,4.7-2.1,4.7-4.7v-41.6H220L220.1,228.7L220.1,228.7z M148.3,201.7h8.9v4.9h-8.9V201.7z"/><path class="st1" d="M231.6,228h3.9c2.6,0,4.7-2.1,4.7-4.7c0-2.6-2.1-4.7-4.7-4.7h-3.9c-2.6,0-4.7,2.1-4.7,4.7C226.9,225.9,229,228,231.6,228z"/></g>';
  res = +'</svg>';
  return res;
};

const url = color => encodeURI('data:image/svg+xml,' + truckSvg(color)).replace(/#/g, '%23');

export const customTruckSvg = (color) => L.icon({
  iconUrl: url(color),
  shadowUrl: iconShadow,
  iconSize: [48, 48],
  iconAnchor: [24, 48],
  shadowSize: [48, 24],
  shadowAnchor: [17, 24],
  popupAnchor: [0, -24]
});
